module.exports = __webpack_public_path__ + "static/media/loader.6207d128.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/loader.gif
// module id = 219
// module chunks = 0